import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MinusIcon, PlusIcon } from "lucide-react";
import { faq } from "../data/content";
import { surface } from "../data/theme";
import { Reveal } from "./Reveal";
import { Section } from "./Section";
import { SectionTitle } from "./SectionTitle";
const ease = [0.23, 1, 0.32, 1] as const;
export function Faq() {
  const [open, setOpen] = useState<number | null>(null);
  return <Section labelledBy="faq-title" className="bg-mist" waveTo={surface.navy} data-id="element-36" data-mp="2dydanfk2mj16">
      <Reveal data-id="element-37" data-mp="291wbzrf8wm9u">
        <SectionTitle id="faq-title" title={faq.title} highlight={faq.highlight} className="text-center" data-id="element-38" data-mp="2924rlr2r65oq" />
      </Reveal>
      <ul className="mt-10 space-y-3" data-id="element-39" data-mp="1z3748rh2ci7b">
        {faq.items.map((item, i) => {
        const isOpen = open === i;
        const panelId = `faq-panel-${i}`;
        return <li key={item.question} className={`rounded-2xl border bg-white transition-[border-color,box-shadow] duration-200 ease-out ${isOpen ? "border-gold/60 shadow-[0_10px_30px_-18px_rgba(13,42,71,0.35)]" : "border-line"}`} data-id="element-40" data-mp="soo97vpnb2ez" data-mpi={i}>
              <h3 data-id="element-41" data-mp="pg3hya51uhrx">
                <button type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 rounded-2xl px-5 py-4 text-left font-bold leading-snug text-navy focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-42" data-mp="ugr4aiic2aft">
                  {item.question}
                  <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors duration-200 ease-out ${isOpen ? "bg-gold-gradient text-navy" : "bg-navy/[0.06] text-navy"}`} data-id="element-43" data-mp="6q55lhu7y2ih">
                    {isOpen ? <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-44" data-mp="1sd6a2r8ve49" /> : <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-45" data-mp="1t53fi0hpjwn" />}
                  </span>
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-46" data-mp="3k0cf5sfqp911">
                {isOpen && <motion.div id={panelId} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: "auto",
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease
            }} className="overflow-hidden" data-id="element-47" data-mp="3nya54xhc3z5h">
                    <p className="px-5 pb-5 leading-relaxed text-navy/75" data-id="element-48" data-mp="1fsq3ysdei07s">{item.answer}</p>
                  </motion.div>}
              </AnimatePresence>
            </li>;
      })}
      </ul>
    </Section>;
}